<div class="cs-d-flex w-100 h-100 cs-flex-1">
    <app-sidebar-nav style="background: #FFF"
        themeName="default"
        (updatedActiveItem)="setCurrentActiveItem($event)"
        [navService]="sidebarNavService">
    </app-sidebar-nav>

    <div class="cs-flex-1 h-100 cs-common-ui--fs-box-inset-shadow pos-rlt parent-instance-history">
        <div class="cs--fs-body-shadow"></div>
        <app-instance-history
            [workflowId]="workflowData.id"
            [metaData]="metaData"
            *ngIf="currentActiveMenuItem.id=='workflow_instanceHistory'">
        </app-instance-history>

        <app-audit-history2
            [workflowId]="workflowData.id"
            [metaData]="metaData"
            *ngIf="currentActiveMenuItem.id=='workflow_auditHistory'">
        </app-audit-history2>
    </div>
</div>
